"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Wrapper_1 = require("./Wrapper");
const inputs_1 = require("../../../inputs");
exports.BlockCanvaAdsInput = ({ value, disabled, onChange, }) => {
    return (react_1.default.createElement(Wrapper_1.BlockCanvasInputWrapper, { padding: true },
        react_1.default.createElement(inputs_1.OsmosysResourceSelectBox, { resource: "ad", value: value, disabled: disabled, onChange: onChange, label: false })));
};
//# sourceMappingURL=AdsInput.js.map